// src/utils/api/fogo.js
import API from "../api";

export async function createFogoPayment({ product, email, buyerWallet, clientRequestId }) {
  try {
    const p = email
      ? { ...product, recipient: { ...(product?.recipient || {}), email } }
      : product;

    const res = await API.post("/fogo/create", {
      product: p,
      buyerWallet,
      clientRequestId,
    });

    const data = res.data;

    if (data == null) {
      throw new Error("Fogo returned an empty response (possible whitelist / gateway issue).");
    }

    if (typeof data === "string") {
      throw new Error(`Fogo returned non-JSON: ${data.slice(0, 200)}`);
    }

    if (data.error) {
      throw new Error(data.message || data.error || "Fogo returned an error");
    }

    return data;
  } catch (err) {
    let msg =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      "Failed to create Fogo payment";

    const needsLogin =
      msg.includes("Missing auth token") ||
      msg.includes("Unauthorized") ||
      msg.includes("jwt expired") ||
      msg.includes("invalid token");

    const e = new Error(needsLogin ? "Please log in to continue." : msg);
    e.code = needsLogin ? "AUTH" : "FOGO_CREATE";
    throw e;
  }
}


export async function confirmFogoPayment({ txnId, purchaseId, type, signature }) {
  try {
    const res = await API.post("/fogo/confirm", {
      txnId,
      purchaseId,
      type,
      signature,
    });

    const data = res.data;

    if (!data || data.error) {
      throw new Error(
        data?.message || data?.error || "Fogo confirm returned an unexpected response"
      );
    }

    return data;
  } catch (err) {
    let msg =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      "Failed to confirm Fogo payment";

    const needsLogin =
      msg.includes("Missing auth token") ||
      msg.includes("Unauthorized") ||
      msg.includes("jwt expired") ||
      msg.includes("invalid token");

    const e = new Error(needsLogin ? "Please log in to continue." : msg);
    e.code = needsLogin ? "AUTH" : "FOGO_CONFIRM";
    throw e;
  }
}

